// extracted by mini-css-extract-plugin
module.exports = {"content":"style_content__1cNbP","icon":"style_icon__3l9t9","title":"style_title__2hF3R","bottomButton":"style_bottomButton__27YRB","bottomButtons":"style_bottomButtons__3V_VX"};